export const SUBMIT_LOADING_MESSAGE = {
  TITLE: '申し込みの手続きをしています。',
  DESCRIPTION:
    '最長で90秒ほどかかることがあります。\n途中で停止すると内容が無効になることがあります。',
};

export const ORDER_SIGN_IN_SUBMIT_LOADING_MESSAGE = {
  TITLE: 'ログインしています。しばらくおまちください。',
  DESCRIPTION:
    '最大20秒ほどかかることがあります。\n途中で停止すると内容が無効になることがあります。',
};

export const ORDER_SIGN_UP_SUBMIT_LOADING_MESSAGE = {
  TITLE: '会員登録しています。しばらくおまちください。',
  DESCRIPTION:
    '最大20秒ほどかかることがあります。\n途中で停止すると内容が無効になることがあります。',
};
